module.exports = __webpack_public_path__ + "img/DE02378.2c401c66.png";